import { render, staticRenderFns } from "./AppointmentTable.vue?vue&type=template&id=d4cd511e&scoped=true&"
import script from "./AppointmentTable.vue?vue&type=script&lang=js&"
export * from "./AppointmentTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4cd511e",
  null
  
)

export default component.exports